import { defineMessages } from 'react-intl';

const translations = {
  properties: {
    articleNumber: {
      id: 'properties.articleNumber',
      defaultMessage: 'Art. Nr. {number}',
      description: 'label of the article number',
    },
    eanNumber: {
      id: 'properties.eanNumber',
      defaultMessage: 'EAN. {number}',
      description: 'label of the ean number',
    },
  },
  actions: {
    close: {
      id: 'actions.close',
      defaultMessage: 'Close',
      description: 'label of the close button',
    },
  },
};

export default defineMessages(translations);
